import FinancialSegmentsFields from "components/stocks/modern/fragments/FinancialSegmentsFields";
import gql from "graphql-tag";

export default gql`
  query FinancialBusinessSegments($tickerSymbol: TickerSymbol!, $country: SecurityCountry!) {
    financialBusinessSegments(tickerSymbol: $tickerSymbol) {
      ...FinancialSegmentsFields
    }
    issuerByTickerSymbol(tickerSymbol: $tickerSymbol, country: $country) {
      ... on BrazilianCompanyIssuer {
        majorCustomers {
          fiscalYear
          flagText
        }
      }
    }
  }

  ${FinancialSegmentsFields}
`;
